import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SigmaLinesComponent } from './sigma-lines.component';
@NgModule({
    declarations: [SigmaLinesComponent],
    exports: [SigmaLinesComponent],
    imports: [CommonModule]
})
export class SigmaLinesModule {}
